const popupAddressCopyOption = document.getElementById(
  "popupAddressCopyOption",
);
const popupAddressCopyOptionMessage = document.getElementById(
  "popupAddressCopyOptionMessage",
);

popupAddressCopyOption.addEventListener("click", () => {
  // Copy the current page URL
  navigator.clipboard
    .writeText("13 bis Rue Saint-Lazare, 49100 Angers")
    .then(() => {
      // Show popupAddressCopyOptionMessage
      popupAddressCopyOptionMessage.classList.add("show");

      // Hide after 2 seconds
      setTimeout(() => {
        popupAddressCopyOptionMessage.classList.remove("show");
      }, 2000);
    })
    .catch((err) => console.error("Failed to copy: ", err));
});

const popupAddressInvoke = document.getElementById("popupAddressInvoke");
const popupAddressOverlay = document.querySelector(".popupAddressOverlay");
//const popupAddressOverlay = document.body;
const body = document.body;
const popupAdressCloseButton = document.querySelector(".popup-address-close");
let popupAddressToggle = false; // false = closed, true = open
let scrollY = 0;

const popupAddressInside = document.querySelector(".popup-address"); // note querySelector, NOT querySelectorAll
// Open popup
popupAddressInvoke.addEventListener("click", (e) => {
  e.stopPropagation();
  if (!popupAddressToggle) {
    scrollY = window.scrollY; // save position
    body.style.overflow = "hidden";
    //body.style.top = `-${scrollY}px`; // keep visual position
    popupAddressOverlay.style.display = "flex";
    popupAddressToggle = true;
  }
});
//close
function closePopup() {
  popupAddressOverlay.style.display = "none";
  body.style.overflow = "";
  body.style.top = "";
  window.scrollTo(0, scrollY); // restore position
  popupAddressToggle = false;
}

// Click outside
popupAddressOverlay.addEventListener("click", (e) => {
  if (e.target === popupAddressOverlay) closePopup();
});

// Close button
popupAdressCloseButton.addEventListener("click", (e) => {
  if (e.target === popupAdressCloseButton) closePopup();
});
